var _rect, _rect2, _path, _path2, _rect3, _ellipse, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKSrTkrbL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 38,
    viewBox: "0 0 28 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.604492,
    y: 0.5,
    width: 26.791,
    height: 37,
    rx: 1.5,
    fill: "#F5F4FA",
    stroke: "#9891CD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.38867,
    y: 2.55957,
    width: 7.99468,
    height: 24.4145,
    rx: 1,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0013 3.55957C12.0013 3.00728 12.4491 2.55957 13.0013 2.55957H24.7065C25.2588 2.55957 25.7065 3.00729 25.7065 3.55957V32.8653C25.7065 33.4176 25.2588 33.8653 24.7065 33.8653H13.0013C12.4491 33.8653 12.0013 33.4176 12.0013 32.8653V3.55957Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0952 31.3789C14.9517 30.7882 16.5126 29.3115 15.9035 28.1302C15.1421 26.6535 14.1903 30.0007 16.2842 31.3789C18.378 32.7571 18.4732 30.8867 18.0925 30.0007C17.7118 29.1146 16.9504 31.4773 19.0442 30.8867C21.1381 30.296 20.0912 29.0162 21.0429 30.8867C21.8043 32.383 22.5023 30.9195 22.7561 30.0007",
    stroke: "#8EDCFF",
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.38867,
    y: 28.7461,
    width: 7.99468,
    height: 4.92228,
    rx: 1,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.48253,
    cy: 4.72492,
    rx: 1.33245,
    ry: 1.37824,
    fill: "#D6D3EB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5242,
    y: 4.13477,
    width: 10.6596,
    height: 1.18135,
    rx: 0.590674,
    fill: "#D6D3EB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5242,
    y: 13.585,
    width: 10.6596,
    height: 1.18135,
    rx: 0.590674,
    fill: "#D6D3EB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5242,
    y: 8.86035,
    width: 10.6596,
    height: 1.18135,
    rx: 0.590674,
    fill: "#D6D3EB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5242,
    y: 18.3105,
    width: 10.6596,
    height: 1.18135,
    rx: 0.590674,
    fill: "#D6D3EB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5242,
    y: 6.49707,
    width: 10.6596,
    height: 1.18135,
    rx: 0.590674,
    fill: "#D6D3EB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5242,
    y: 15.9482,
    width: 10.6596,
    height: 1.18135,
    rx: 0.590674,
    fill: "#D6D3EB"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5242,
    y: 11.2227,
    width: 10.6596,
    height: 1.18135,
    rx: 0.590674,
    fill: "#D6D3EB"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5242,
    y: 20.6738,
    width: 10.6596,
    height: 1.18135,
    rx: 0.590674,
    fill: "#D6D3EB"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5242,
    y: 23.0361,
    width: 6.85259,
    height: 1.18135,
    rx: 0.590674,
    fill: "#D6D3EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKSrTkrbL);
export default __webpack_public_path__ + "static/media/KSrTkrbL.f8c02cd53f67fe0425904a589585e89a.svg";
export { ForwardRef as ReactComponent };